export default __webpack_public_path__ + "static/media/INICIO.c1bfd2ce.png";